import React from 'react'
import parse from 'html-react-parser'
import { splitFill } from '../../utils'

export function Header({ headers, id }) {
  return (
    <>
      <h3 id={id}>Header</h3>
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {headers.map(header => (
            <tr key={header.field}>
              <td>
                {parse(splitFill(header.field))}
                {header.optional && <sub className='label-optional'>optional</sub>}
              </td>
              <td>{header.type}</td>
              <td>
                {parse(header.description)}
                {header.defaultValue && <code>Default value: {header.defaultValue}</code>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
